import React, { useEffect } from "react";
import AOS from "aos";
import { Link } from "react-scroll";
import { useLocation } from "react-router-dom";
import logo from "../../images/logo/logo-white.webp";
import Shape1 from "../../images/mail.svg";
import News1 from "../../images/phone.svg";
import News2 from "../../images/map.svg";
import termsDocument from "../../documents/privace-policy.pdf";
import menus from "../../api/menus";

const Footer = (props) => {
  const location = useLocation();
  const isHome = location.pathname === "/";
  useEffect(() => {
    AOS.init({
      offset: -1000,
      duration: 1000,
      easing: "ease-in-sine",
      delay: 100,
      once: true,
    });
  }, []);
  return (
    <footer className="wpo-site-footer" data-aos="fade-down">
      <div className="wpo-upper-footer">
        <div className="container">
          <div className="row">
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget about-widget">
                <div className="logo widget-title">
                  <img src={logo} alt="CreaSnap" loading="lazy" />
                </div>
                <p>
                  CreaSnap merupakan agency yang bergerak di bidang jasa
                  pengelolaan media sosial yang berfokus pada membantu bisnis,
                  UMKM, dan individu dalam membangun serta mengoptimalkan
                  kehadiran digital, khususnya melalui platform Instagram.
                </p>

                <div className="social-widget">
                  <ul>
                    <li>
                      <a
                        href={`mailto:cs@${props.contact.email.username}`}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={`Kirim email ke dukungan pelanggan di ${props.contact.email.username}`}
                      >
                        <i
                          className="ti-email"
                          role="presentation"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </li>
                    <li>
                      <a
                        href={`https://www.instagram.com/${props.contact.instagram.username}`}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={`Hubungi via instagram di ${props.contact.instagram.username}`}
                      >
                        <i
                          className="ti-instagram"
                          role="presentation"
                          aria-hidden="true"
                        ></i>
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget link-widget s2">
                <div className="widget-title">
                  <h3>Useful Links</h3>
                </div>
                <ul>
                  {menus.map((menu, mindex) => (
                    <li key={mindex}>
                      {isHome ? (
                        <Link
                          to={menu.link}
                          spy={true}
                          smooth={true}
                          offset={menu.offset}
                          duration={500}
                          aria-label={menu.label}
                        >
                          {menu.title}
                        </Link>
                      ) : (
                        // eslint-disable-next-line jsx-a11y/anchor-has-content
                        <a href="/" rel="noreferrer" aria-label={menu.label}>
                          {menu.title}
                        </a>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className="col col-lg-4 col-md-6 col-sm-12 col-12">
              <div className="widget contact-widget">
                <div className="widget-title">
                  <h3>Contact Us</h3>
                </div>
                <ul>
                  <li>
                    <img
                      src={Shape1}
                      alt="Email Icon CreaSnap"
                      loading="lazy"
                    />{" "}
                    <span>{props.contact.email.username}</span>
                  </li>
                  <li>
                    <img
                      src={News1}
                      alt="Telephone Icon CreaSnap"
                      loading="lazy"
                    />{" "}
                    <span>
                      {" "}
                      +
                      {props.contact.telephone.username
                        .match(/.{1,4}/g)
                        .join("-")}
                    </span>
                  </li>
                  <li>
                    <img
                      src={News2}
                      alt="Location Icon CreaSnap"
                      loading="lazy"
                    />{" "}
                    <span>
                      {props.contact.location.address},{" "}
                      {props.contact.location.subdistrict}. <br />
                      {props.contact.location.city},{" "}
                      {props.contact.location.province}{" "}
                      {props.contact.location.postalCode}.
                    </span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="wpo-lower-footer">
        <div className="container">
          <div className="row g-0">
            <div className="col col-lg-6 col-12">
              <p className="copyright">
                {" "}
                Copyright &copy; 2024 by{" "}
                <a href="/" rel="noreferrer" aria-label="Menuju Halaman Home">
                  CreaSnap
                </a>
                . All Rights Reserved.
              </p>
            </div>
            <div className="col col-lg-6 col-12">
              <ul>
                <li>
                  <a
                    href={termsDocument}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Menuju Halaman Privace & Policy"
                  >
                    Privace & Policy
                  </a>
                </li>
                <li>
                  <a
                    href={termsDocument}
                    target="_blank"
                    rel="noreferrer"
                    aria-label="Menuju Halaman Terms"
                  >
                    Terms
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
